export class Food {

    foodID: number;
    foodName: string;
    imagePath: string;
    upcScan: string;
    factoryID: number;
    factory: {
        factoryID: number,
        factoryName: string
    };
    foodClassificationID: number;
    foodClassification: {
        foodClassificationID: number,
        foodClassificationName: string
    };
    measurement: {
        measurementID: number;
        measurementName: string;
    };
    measurementID: number;
    factoryString: string;
    fullPath: string;

    constructor() {

    }
}
